// import { Message } from 'element-ui'
import AppClipboard from '@/components/AppClipboard/index.js'
import AppActivation from '@/components/AppActivation/index.js'
import store from '@/store'
console.log(store, 'store') // 未找到使用 stor
// highlight
import '@/assets/css/markdown-css/github-markdown-light.css'
import 'highlight.js/styles/atom-one-dark.css'
import hljs from 'highlight.js'

export default function registerGlobalDirectives(Vue) {
  // 未找到使用
  // Vue.directive('testalert', {
  //   componentUpdated: (el, binding) => {
  //     el.onclick = () => {
  //       console.log(binding, '111')
  //       Message.warning({
  //         message: '敬请期待'
  //       })
  //     }
  //   },
  //   unbind(el) {
  //     el.onclick = null
  //   }
  // })

  Vue.directive('share', {
    inserted: (el, binding) => {
      el.onclick = async () => {
        await store.dispatch('global/getDynamicH5Url', {
          moduleCode: 'material_goods'
        })
        const url = `${store.getters['h5Url']}${binding.value}`
        const tenantId = JSON.parse(localStorage.getItem('orgInfo')).organizationId
        const separator = url.includes('?') ? '&' : '?'
        if (url.includes('tenantId')) {
          AppClipboard.open({ src: `${url}` })
        } else {
          AppClipboard.open({ src: `${url}${separator}tenantId=${tenantId}` })
        }

      }
    },
    componentUpdated: (el, binding) => {
      el.onclick = async () => {
        await store.dispatch('global/getDynamicH5Url', {
          moduleCode: 'material_goods'
        })
        const url = `${store.getters['h5Url']}${binding.value}`
        const tenantId = JSON.parse(localStorage.getItem('orgInfo')).organizationId
        const separator = url.includes('?') ? '&' : '?'
        if (url.includes('tenantId')) {
          AppClipboard.open({ src: `${url}` })
        } else {
          AppClipboard.open({ src: `${url}${separator}tenantId=${tenantId}` })
        }
      }
    },
    unbind(el) {
      el.onclick = null
    }
  })

  Vue.directive('activation', {
    componentUpdated: (el, binding) => {
      el.onclick = () => {
        AppActivation.open({
          src: process.env.VUE_APP_ACTIVATION_URL + binding.value
        })
      }
    },
    unbind(el) {
      el.onclick = null
    }
  })

  // highlight
  Vue.directive('highlight', function (el) {
    const blocks = el.querySelectorAll('pre code')
    blocks.forEach(block => {
      hljs.highlightElement(block)
      block.classList.add('hljs')
    })
  })

  Vue.directive('removeAriaHidden', {
    bind(el, binding) {
      const ariaEls = el.querySelectorAll('.el-radio__original')
      ariaEls.forEach(item => {
        item.removeAttribute('aria-hidden')
      })
      // 触发组件卸载
      // el.parentNode.removeChild(el)
    }
  })
}